import React, { ChangeEvent, useCallback, useState } from "react"
import { useTranslation } from "react-i18next"
import { useValidierteRechnungStore } from ".."
import { rechnungFormats } from "../Utils"
import RadioGroup from "../components/RadioGroup"
import * as Components from "../components/components"
import { EventBus } from "../eventbus"
import { useStoreRechnungEverything } from "../store"
import ValidierungBerichtView from "./ValidierungBerichtView"
import { ValidierungView } from "./ValidierungView"

export default function RechnungErstellenView() {
    const { t } = useTranslation()
    const [format, setFormat] = useState("UBL")
    const [loading, setLoading] = useState({ validate: false, caching: false, creating: false, showing: false })
    const rechnung = useStoreRechnungEverything()
    const onChangeFormat = useCallback((_: ChangeEvent<HTMLInputElement>, value: string) => setFormat(value), [])

    const validierteRechnung = useValidierteRechnungStore()

    const onCaching = useCallback(() => {
        setLoading((l) => ({ ...l, creating: true }))
        EventBus.instance.emit("creating", rechnung, "SCA", () => setLoading((l) => ({ ...l, creating: false })))
    }, [rechnung])

    const onValidate = useCallback(() => {
        setLoading((l) => ({ ...l, validate: true }))
        EventBus.instance.emit("validate", rechnung, format, () => setLoading((l) => ({ ...l, validate: false })))
    }, [format, rechnung])

    const onCreating = useCallback(() => {
        setLoading((l) => ({ ...l, creating: true }))
        EventBus.instance.emit("creating", rechnung, format, () => setLoading((l) => ({ ...l, creating: false })))
    }, [format, rechnung])

    const onShowing = useCallback(() => {
        setLoading((l) => ({ ...l, showing: true }))
        EventBus.instance.emit("visualization", validierteRechnung, () => setLoading((l) => ({ ...l, showing: false })))
    }, [validierteRechnung])

    return (
        <Components.Collapsible title={t("general.generierung.erstelleXRechnung")}>
            {rechnungFormats && rechnungFormats.length > 1 && (
                <Components.Row>
                    <Components.Col align={Components.Align.LEFT}>
                        <RadioGroup name={t("general.generierung.formatText")} values={rechnungFormats} value={format} onChange={onChangeFormat} />
                    </Components.Col>
                </Components.Row>
            )}
            <Components.Row>
                <div className="col-6 col-ms-6">
                    <Components.Button
                        style={Components.ButtonStyle.PRIMARY}
                        id="validate"
                        label={t("general.generierung.buttons.validate.label")}
                        onClick={onValidate}
                        loading={loading.validate}
                        disabled={loading.validate}
                    />
                    <Components.Button
                        style={Components.ButtonStyle.SECONDARY}
                        id="caching"
                        className={"ms-3"}
                        label={t("general.generierung.buttons.caching.label")}
                        tooltip={`<div style='font-size: 1.1rem'>${t("general.generierung.buttons.caching.tooltip")}</div>`}
                        onClick={onCaching}
                        loading={loading.caching}
                        disabled={loading.caching}
                    />
                </div>
                <div className="text-end col-6 col-ms-6">
                    <Components.Button
                        id="showing"
                        style={Components.ButtonStyle.SECONDARY}
                        label={t("general.generierung.buttons.showing.label")}
                        disabled={[undefined, false].includes(validierteRechnung?.validierungErfolgreich) || loading.showing}
                        tooltip={`<div style='font-size: 1.1rem'>${t("general.generierung.buttons.showing.tooltip")}</div>`}
                        onClick={onShowing}
                        loading={loading.showing}
                    />
                    <Components.Button
                        id="creating"
                        style={Components.ButtonStyle.PRIMARY}
                        className={"ms-3"}
                        label={t("general.generierung.buttons.creating.label")}
                        disabled={[undefined, false].includes(validierteRechnung?.validierungErfolgreich) || loading.creating}
                        tooltip={`<div style='font-size: 1.1rem'>
                                ${
                                    [undefined, false].includes(validierteRechnung?.validierungErfolgreich)
                                        ? t("general.generierung.buttons.creating.error")
                                        : t("general.generierung.buttons.creating.success")
                                }
                            </div>`}
                        onClick={onCreating}
                        loading={loading.creating}
                    />
                </div>
            </Components.Row>
            {validierteRechnung && (
                <Components.Row>
                    <div id="MessageContainer">
                        <ValidierungBerichtView rechnung={validierteRechnung} />
                    </div>
                </Components.Row>
            )}
            {validierteRechnung?.validierungFehler && validierteRechnung.validierungFehler.length > 0 && (
                <Components.Row>
                    <div id="validierungContainer">
                        <ValidierungView messages={validierteRechnung.validierungFehler} />
                    </div>
                </Components.Row>
            )}
        </Components.Collapsible>
    )
}
